import React from "react";
import { UserDto } from "../api";

export interface UserContextSchema {
  user?: UserDto;
  setUser: (user?: UserDto) => void;
}

export const UserContext = React.createContext<UserContextSchema>({} as UserContextSchema);
